// Main.js file.
// IIFE - Immediately Invoked Function Expression
(function (yourcode) {
    // The global jQuery object is passed as a parameter
    yourcode(window.jQuery, window, document);
}(function ($, window, document) {
    // The $ is now locally scoped
    // Listen for the jQuery ready event on the document
    $(function () {
// The DOM is ready!


        /**
         *  Hero image height
         */

        if ($('.content-hero').length) {
            var image_url;
            image_url = $('.content-hero').css('background-image');
            var image;
            image_url = image_url.match(/^url\("?(.+?)"?\)$/);
            // image = new Image();
            // image.src = image_url;
            if (image_url != null) {
                image_url = image_url[1];
                image = new Image();
                image.src = image_url;

                // just in case it is not already loaded
                $(image).load(function () {
                    if($(window).width() > 1023) {
                        $('.content-hero').height(image.height);
                    }else {
                        $('.content-hero').css('min-height', '200px');
                    }
                });

                $(window).resize(function () {
                    if($(window).width() > 1023) {
                        $('.content-hero').height(image.height);
                    }else {
                        $('.content-hero').css('min-height', '200px');
                        $('.content-hero').css('height', 'auto');
                    }
                });
            }
        }

        /**
         *  Open/Close mobile menu
         */

        $('.navbar-toggler').click(function () {
           $('.section-mobile-navigation').slideToggle();
           // $(this).attr('aria-expanded', 'true');
           $(this).attr('aria-expanded', function(index, attr){
               return attr == 'true' ? 'false' : 'true';
           });
        });


        /**
         *  Sticky menu
         */

        $(window).scroll(function () {
            if($(document).scrollTop() > 40) {
                $('.main-navigation-wrapper').addClass('is--sticky');
                $('#content').css('margin-top', '72px');
            }else {
                $('.main-navigation-wrapper').removeClass('is--sticky');
                $('#content').css('margin-top', '0');
            }
        });



    });
}));